import { useEffect, useState } from 'react';

// web-rnw twin of ./onceFlag.ts (see that file's header) — same one-shot
// flag shape, localStorage instead of AsyncStorage.
export type OnceFlag = {
  get: () => boolean;
  load: () => Promise<boolean>;
  mark: () => Promise<void>;
};

export function makeOnceFlag(key: string): OnceFlag {
  let snapshot = false;
  return {
    get: () => snapshot,
    load: async () => {
      try {
        snapshot = localStorage.getItem(key) === '1';
      } catch {
        // Keep the current snapshot; it re-persists on the next mark.
      }
      return snapshot;
    },
    mark: async () => {
      snapshot = true;
      try {
        localStorage.setItem(key, '1');
      } catch {
        // Snapshot already set; persistence retries on the next mark.
      }
    },
  };
}

export function useOnceFlag(flag: OnceFlag, watch?: unknown): boolean {
  const [seen, setSeen] = useState(flag.get());
  useEffect(() => {
    let alive = true;
    void flag.load().then((v) => {
      if (alive) setSeen(v);
    });
    return () => {
      alive = false;
    };
  }, [flag, watch]);
  return seen;
}
